import React from 'react';
import * as S from './styled';
export const FieldsetRow = ({ variant = 'medium', inner, noMargin = false, children }) => {
    return (React.createElement(S.Container, { "$variant": variant, "$inner": inner, "$noMargin": noMargin }, children));
};
